import { connect } from "react-redux"
import LayoutSvgUploader from "./LayoutSvgUploader"

const mapStateToProps = (state, props) => ({})

const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(LayoutSvgUploader)
